cb.define([], function () {
  var RM_rm_gatheringvouch_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
      viewmodel.on('uquery', function () {
		 // debugger;
        var proxy = cb.rest.DynamicProxy.create({
          settle: { url: 'bill/uquery', method: 'POST' }
        });
        var params = {
			billnum : "rm_gatheringvouch",
          //customer: viewmodel.get('customer').getValue(),
          id: viewmodel.get('id').getValue()
        };
        proxy.settle(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
		  if (result != undefined) {
			  //debugger
			  var resInfo = JSON.parse(result);
			 // var resInfo = eval('(' + result + ')');
			 // alert(resInfo.id);
			 var params = {
				 mode: 'edit',
				 readOnly: true,
				 id: resInfo.iRetailid
			 };
			 var data = {
				 billtype: 'voucher',
				 billno: 'rm_retailvouch',
				 params: params
			 };
			 cb.loader.runCommandLine('bill', data, viewmodel)
		  }
		  
          //viewmodel.execute('refresh');
          //cb.utils.alert('�ͻ�����ִ�гɹ�', 'success');
        });
      });
    },
 
  }
  try {
    module.exports = RM_rm_gatheringvouch_VM_Extend;
  } catch (error) {

  }
  return RM_rm_gatheringvouch_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_gatheringvouch_VM.Extend.js